////////
// Filter
// - Manages all filter controls
////////
var Filter = function(element) {

	this.selectors = {

		main: ".filter",
		value: ".filter-value",
    panel: ".filter-panel",
    options: ".filter-options"
	};

	this.flags = {
		ACTIVE: "active"
	};

	this.element = $(this.selectors.main);
	this.valueEl = $(this.selectors.value);
	this.valueEl.on("click", this, this.toggleDisplay);
}

Filter.prototype.toggleDisplay = function(e) {
	var obj = e.data;
	obj.element.toggleClass(obj.flags.ACTIVE);
	// obj.valueEl.toggleClass("i-close");
}
